import type { Route } from '@angular/router';
import { dirtyCheckCanDeactivateGuard } from '../../common/dirty-check/dirty-check';
import { hasStringPathParamCanActivateGuard } from '@pct/ng-core-router';

export const onboardingStepRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./list/onboarding-step-list.component'),
    pathMatch: 'full',
  },
  {
    path: 'new',
    loadComponent: () => import('./details/onboarding-step-details.component'),
    title: 'PAGES.ONBOARDING_STEP.BREADCRUMB.NEW',
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
  {
    path: ':id',
    loadComponent: () => import('./details/onboarding-step-details.component'),
    title: 'PAGES.ONBOARDING_STEP.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
];
